import { Module } from '@nestjs/common';
import { JwtModule } from '@nestjs/jwt';
import { PagosProveedorModule } from 'src/pagos-proveedor/pagos-proveedor.module';
import { envs } from 'src/config';
import { AuditModule } from '../audit/audit.module';
import { MarangatuConfigService } from './marangatu-config.service';
import { MarangatuSyncService } from './marangatu-sync.service';
import { MarangatuGateway } from './marangatu.gateway';
import { MarangatuController } from './marangatu.controller';

@Module({
  imports: [AuditModule, PagosProveedorModule, JwtModule.register({ secret: envs.jwtSecret })],
  controllers: [MarangatuController],
  providers: [MarangatuGateway, MarangatuConfigService, MarangatuSyncService],
  exports: [MarangatuConfigService],
})
export class MarangatuModule {}
